module.exports = __webpack_public_path__ + "img/logo.fb6b1015.png";